var render, staticRenderFns
import script from "./GpaChart.vue?vue&type=script&lang=js&"
export * from "./GpaChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e489c3c",
  null
  
)

export default component.exports